import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

// Animation Variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

const imageVariants = {
  hidden: { 
    opacity: 0, 
    y: 60,
    scale: 0.9
  },
  visible: { 
    opacity: 1, 
    y: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};

const AboutContainer = styled.section`
  padding: 4rem 2rem;
  background-color: #ffffff;
  color: #333333;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
    gap: 1.5rem;
  }
`;

const AboutTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const AboutBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
  gap: 2rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

const AboutText = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 0; /* Remove bottom margin for better alignment */
  max-width: 500px;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  width: 100%;

  @media (min-width: 769px) {
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    max-width: 800px;
  }
`;

const TopRow = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: flex;
    gap: 1rem;
    justify-content: center;
    width: 100%;
  }
`;

const BottomRow = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: flex;
    gap: 1rem;
    justify-content: center;
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  @media (min-width: 769px) {
    flex: 0 0 auto;
  }
`;

const AboutImage = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }

  @media (min-width: 769px) {
    max-width: 500px;
    height: 350px;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const AboutUs = () => {
  return (
    <AboutContainer>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
        variants={containerVariants}
      >
        <ImageContainer>
          <TopRow>
            <motion.div variants={imageVariants}>
              <ImageWrapper>
                <AboutImage src="/images/Black logo name.jpg" alt="NovaHomes Team" />
              </ImageWrapper>
            </motion.div>
            <motion.div variants={imageVariants}>
              <ImageWrapper>
                <AboutImage src="/images/House with keys.jpg" alt="Modern Living Room" />
              </ImageWrapper>
            </motion.div>
          </TopRow>
          <BottomRow>
            <motion.div variants={imageVariants}>
              <ImageWrapper>
                <AboutImage src="/images/home focus.jpg" alt="Happy Family" />
              </ImageWrapper>
            </motion.div>
            <motion.div variants={imageVariants}>
              <ImageWrapper>
                <AboutImage src="/images/home memories.jpg" alt="Luxury Property" />
              </ImageWrapper>
            </motion.div>
            <motion.div variants={imageVariants}>
              <ImageWrapper>
                <AboutImage src="/images/handshake.jpg" alt="Real Estate Agent" />
              </ImageWrapper>
            </motion.div>
          </BottomRow>
        </ImageContainer>
      </motion.div>
    </AboutContainer>
  );
};

export default AboutUs;